<template>
  <div class="studio-announcement flex-md-row">
    <span class="announcement-text">
      {{ announcement.text }}
    </span>
    <a
      class="link-learn-more undecorated-router-link"
      :target="target"
      v-if="announcement.link"
      :href="announcement.link"
    >
      {{ $t('STUDIO.LINKS.LEARN_MORE') }}
    </a>
  </div>
</template>

<script>

export default {
  name: 'StudioAnnouncement',
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    target() {
      return this.announcement.open_in_new_tab ? '_blank' : '_self';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.studio-announcement {
  display: flex;
  flex-direction: column;
  background-color: var(--brand-color-with-opacity-02);
  border-radius: $border-radius;
  color: $charcoal;
  text-align: center;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    text-align: left;
  }
}

.announcement-text {
  display: block;
  padding: 1rem;
  flex: 1;
}

.link-learn-more {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border-top: 2px solid white;
  &:hover {
    background-color: var(--brand-color-with-opacity-03);
  }
  @media screen and (min-width: 768px) {
    border-top: none;
    border-left: 2px solid white;
  }
}
</style>
